<script setup lang="ts">
    import { INSIGHTS_ICONS } from '../insights-icons';
    import type { InsightsIconName } from '../insights-icons';

    const props = withDefaults(
        defineProps<{
            icon: InsightsIconName;
            size?: number;
        }>(),
        {
            size: 20,
        }
    );
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="insights-icon d-inline-block flex-shrink-0"
        :width="props.size"
        :height="props.size"
        viewBox="0 -960 960 960"
        fill="currentColor"
        aria-hidden="true"
    >
        <path :d="INSIGHTS_ICONS[props.icon]"></path>
    </svg>
</template>
